(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geeta-flash-sale"] && !Shopify.designMode) return;
  try {
    
// 确保脚本在正确的位置初始化
// 这里的代码会被自动插入到页面底部

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geeta-ticket-gmail"] && !Shopify.designMode) return;
  try {
    
// Issue type mapping
const issueTypes = {
    "Before You Buy": [
        "Product Details",
        "Wig Features & Styles",
        "Sales Promotion"
    ],
    "Order & Payments": [
        "Order Issues & Adjustments",
        "Payment Issues",
        "Tax Issues"
    ],
    "Track & Shipping": [
        "Shipping & Delivery",
        "Tracking Order",
        "Missing Package",
        "Damaged Package"
    ],
    "After-sales Support": [
        "Wig Usage & Installation",
        "Wig Maintenance & Care",
        "Return & Refund"
    ],
    "VIP & Account": [
        "VIP Rewards",
        "Account Management"
    ],
    "Refer & Earn": [
        "Refer & Earn"
    ],
    "Frequently asked questions": [
        "General Questions"
    ]
};

// Order-related categories
const orderRelatedCategories = [
    "Order & Payments",
    "Track & Shipping",
    "After-sales Support"
];

// Get Worker URL from hidden field
const workerUrl = document.getElementById('workerUrlField').value;

// Add debugging info
console.log('Worker URL configured as:', workerUrl);

// Validate workerUrl immediately
if (!workerUrl || workerUrl === '' || workerUrl === '{{ section.settings.worker_url }}') {
    console.error('Error: Worker URL is not configured properly. Please set the Worker URL in the section settings.');
    alert('Error: Worker URL is not configured. Please contact support.');
}

// Global variables
let uploadedFiles = [];
let selectedOrder = null;

// Initialize form
function initForm() {
    const categorySelect = document.getElementById('issueCategory');
    const subcategorySelect = document.getElementById('issueSubcategory');
    const emailInput = document.getElementById('email');
    const fileUpload = document.getElementById('fileUpload');
    const fileInput = document.getElementById('fileInput');
    const form = document.getElementById('ticketForm');

    // Issue category change handler
    categorySelect.addEventListener('change', handleCategoryChange);
    
    // Email change handler for order lookup
    emailInput.addEventListener('change', handleEmailChange);
    
    // File upload handlers
    fileUpload.addEventListener('click', () => fileInput.click());
    fileInput.addEventListener('change', handleFileSelect);
    fileUpload.addEventListener('dragover', handleDragOver);
    fileUpload.addEventListener('drop', handleDrop);
    
    // Form submission handler
    form.addEventListener('submit', handleFormSubmit);
}

// Handle issue category change
function handleCategoryChange() {
    const categorySelect = document.getElementById('issueCategory');
    const subcategorySelect = document.getElementById('issueSubcategory');
    const selectedCategory = categorySelect.value;
    
    console.log('Category changed to:', selectedCategory);
    
    // Clear existing options
    subcategorySelect.innerHTML = '<option value="">Select Subcategory</option>';
    
    // Populate subcategories
    if (selectedCategory && issueTypes[selectedCategory]) {
        issueTypes[selectedCategory].forEach(subcategory => {
            const option = document.createElement('option');
            option.value = subcategory;
            option.textContent = subcategory;
            subcategorySelect.appendChild(option);
        });
    }
    
    // Show/hide order section based on category
    const orderSection = document.getElementById('orderSection');
    if (orderRelatedCategories.includes(selectedCategory)) {
        orderSection.style.display = 'block';
        // Trigger order lookup if email is provided
        const email = document.getElementById('email').value;
        if (email) {
            lookupOrders(email);
        }
    } else {
        orderSection.style.display = 'none';
        selectedOrder = null;
        document.getElementById('selectedOrder').value = '';
        document.getElementById('orderList').innerHTML = '';
    }
}

// Handle email change for order lookup
function handleEmailChange() {
    const email = this.value;
    const categorySelect = document.getElementById('issueCategory');
    const selectedCategory = categorySelect.value;
    
    // Only lookup orders if category is order-related
    if (email && orderRelatedCategories.includes(selectedCategory)) {
        lookupOrders(email);
    }
}

// Lookup orders from Shopify via Worker
async function lookupOrders(email) {
    const orderList = document.getElementById('orderList');
    const orderLoading = document.getElementById('orderLoading');
    
    orderLoading.classList.remove('hidden');
    orderList.innerHTML = '';
    
    try {
        // Validate workerUrl
        if (!workerUrl || workerUrl === '') {
            orderList.innerHTML = '<div style="padding: 1rem; text-align: center; color: #e53e3e;">Error: Worker URL is not configured.</div>';
            return;
        }
        
        const ordersUrl = `${workerUrl}/orders?email=${encodeURIComponent(email)}`;
        console.log('Looking up orders at:', ordersUrl);
        
        const response = await fetch(ordersUrl);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const orders = await response.json();
        
        if (orders.length > 0) {
            orders.forEach(order => {
                const orderItem = document.createElement('div');
                orderItem.className = 'order-item';
                orderItem.innerHTML = `
                    <strong>${order.name}</strong><br>
                    Status: ${order.status}<br>
                    Date: ${new Date(order.created_at).toLocaleDateString()}
                `;
                orderItem.dataset.order = JSON.stringify(order);
                orderItem.addEventListener('click', () => selectOrder(orderItem));
                orderList.appendChild(orderItem);
            });
        } else {
            orderList.innerHTML = '<div style="padding: 1rem; text-align: center; color: #666;">No orders found for this email.</div>';
        }
    } catch (error) {
        console.error('Error looking up orders:', error);
        orderList.innerHTML = `<div style="padding: 1rem; text-align: center; color: #e53e3e;">Failed to load orders: ${error.message}</div>`;
    } finally {
        orderLoading.classList.add('hidden');
    }
}

// Select an order
function selectOrder(orderItem) {
    // Remove selected class from all items
    document.querySelectorAll('.order-item').forEach(item => {
        item.classList.remove('selected');
    });
    
    // Add selected class to clicked item
    orderItem.classList.add('selected');
    
    // Store selected order
    selectedOrder = JSON.parse(orderItem.dataset.order);
    document.getElementById('selectedOrder').value = JSON.stringify(selectedOrder);
}

// Handle file selection
function handleFileSelect(event) {
    const files = Array.from(event.target.files);
    processFiles(files);
    event.target.value = ''; // Reset input
}

// Handle drag over
function handleDragOver(event) {
    event.preventDefault();
    event.currentTarget.style.borderColor = '#0070f3';
}

// Handle drop
function handleDrop(event) {
    event.preventDefault();
    event.currentTarget.style.borderColor = '#ddd';
    const files = Array.from(event.dataTransfer.files);
    processFiles(files);
}

// Process files for upload
async function processFiles(files) {
    for (const file of files) {
        // Validate file size
        if (!validateFileSize(file)) {
            alert(`${file.name} exceeds the file size limit.`);
            continue;
        }
        
        let processedFile = file;
        
        // Compress images
        if (file.type.startsWith('image/')) {
            processedFile = await compressImage(file);
        }
        
        // Upload file to R2
        const uploadUrl = await uploadFile(processedFile);
        if (uploadUrl) {
            uploadedFiles.push({
                name: file.name,
                url: uploadUrl,
                type: file.type
            });
            updateFilePreview();
        }
    }
}

// Validate file size
function validateFileSize(file) {
    if (file.type.startsWith('image/')) {
        return file.size <= 10 * 1024 * 1024; // 10MB for images
    } else if (file.type.startsWith('video/')) {
        return file.size <= 50 * 1024 * 1024; // 50MB for videos
    }
    return false;
}

// Compress image
async function compressImage(file) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                
                // Resize image to max 1920px width/height
                let width = img.width;
                let height = img.height;
                const maxSize = 1920;
                
                if (width > height && width > maxSize) {
                    height = Math.round((height * maxSize) / width);
                    width = maxSize;
                } else if (height > maxSize) {
                    width = Math.round((width * maxSize) / height);
                    height = maxSize;
                }
                
                canvas.width = width;
                canvas.height = height;
                
                // Draw image
                ctx.drawImage(img, 0, 0, width, height);
                
                // Convert to blob
                canvas.toBlob(
                    (blob) => {
                        resolve(new File([blob], file.name, { type: file.type }));
                    },
                    file.type,
                    0.8 // Compression quality
                );
            };
        };
    });
}

// Upload file to R2 via Worker
async function uploadFile(file) {
    try {
        // Validate workerUrl
        if (!workerUrl || workerUrl === '') {
            alert('Error: Worker URL is not configured. Please contact support.');
            return null;
        }
        
        const uploadUrl = `${workerUrl}/upload`;
        console.log('Uploading file to:', uploadUrl);
        
        const formData = new FormData();
        formData.append('file', file);
        
        const response = await fetch(uploadUrl, {
            method: 'POST',
            body: formData
        });
        
        if (response.ok) {
            const data = await response.json();
            return data.url;
        } else {
            const errorText = await response.text();
            console.error('File upload error:', errorText);
            alert(`File upload failed: ${response.status} ${response.statusText}`);
            return null;
        }
    } catch (error) {
        console.error('Error uploading file:', error);
        alert(`File upload error: ${error.message}`);
        return null;
    }
}

// Update file preview
function updateFilePreview() {
    const previewContainer = document.getElementById('filePreview');
    previewContainer.innerHTML = '';
    
    uploadedFiles.forEach((file, index) => {
        const previewItem = document.createElement('div');
        previewItem.className = 'file-preview-item';
        
        if (file.type.startsWith('image/')) {
            previewItem.innerHTML = `
                <img src="${file.url}" alt="${file.name}">
                <button class="remove-btn" onclick="removeFile(${index})">×</button>
            `;
        } else if (file.type.startsWith('video/')) {
            previewItem.innerHTML = `
                <video controls>
                    <source src="${file.url}" type="${file.type}">
                </video>
                <button class="remove-btn" onclick="removeFile(${index})">×</button>
            `;
        }
        
        previewContainer.appendChild(previewItem);
    });
    
    // Update hidden input
    document.getElementById('uploadedFiles').value = JSON.stringify(uploadedFiles);
}

// Remove file from upload list
function removeFile(index) {
    uploadedFiles.splice(index, 1);
    updateFilePreview();
}

// Handle form submission
async function handleFormSubmit(event) {
    event.preventDefault();
    
    // Validate workerUrl with template syntax check
    if (!workerUrl || workerUrl === '' || workerUrl.includes('{{') || workerUrl.includes('}}')) {
        const errorMsg = 'Error: Worker URL is not configured properly. Please follow these steps:\n1. Go to Shopify Admin > Online Store > Themes > Customize\n2. Find "Shopify Ticket Form (Gmail Version)" section\n3. Enter your Cloudflare Worker URL in the "Worker URL" field\n4. Save the changes\n\nIf you need help, please contact support.';
        console.error(errorMsg);
        console.log('Current Worker URL:', workerUrl);
        alert(errorMsg);
        return;
    }
    
    const form = event.target;
    const submitBtn = document.getElementById('submitBtn');
    
    // Validate form
    if (!validateForm()) {
        return;
    }
    
    // Show loading state
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="loading"></span> Submitting...';
    
    try {
        // Create JSON payload instead of FormData
        const payload = {
            email: document.getElementById('email').value,
            phone: document.getElementById('phone').value,
            issueCategory: document.getElementById('issueCategory').value,
            issueSubcategory: document.getElementById('issueSubcategory').value,
            message: document.getElementById('message').value,
            selectedOrder: selectedOrder,
            uploadedFiles: uploadedFiles
        };
        
        // Print API URL for debugging - 使用 Gmail 端点
        const apiUrl = `${workerUrl}/gmail-ticket`;
        console.log('Submitting ticket to:', apiUrl);
        console.log('Submission payload:', payload);
        
        // Submit form with JSON
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        
        // Print response status
        console.log('Response status:', response.status);
        
        const responseData = await response.json();
        console.log('Response data:', responseData);
        
        if (response.ok) {
            console.log('Ticket submission result:', responseData);
            alert('Ticket submitted successfully!');
            form.reset();
            resetForm();
        } else {
            console.error('Error response:', responseData);
            alert(`Failed to submit ticket: ${response.status} ${responseData.error || response.statusText}`);
        }
    } catch (error) {
        console.error('Error submitting ticket:', error);
        alert(`Failed to submit ticket: ${error.message}`);
    } finally {
        // Reset button state
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'Submit Ticket';
    }
}

// Validate form
function validateForm() {
    let isValid = true;
    
    // Reset errors
    document.querySelectorAll('.error-message').forEach(el => el.textContent = '');
    
    // Validate email
    const email = document.getElementById('email').value;
    if (!email) {
        document.getElementById('emailError').textContent = 'Email is required.';
        isValid = false;
    }
    
    // Validate issue type
    const category = document.getElementById('issueCategory').value;
    const subcategory = document.getElementById('issueSubcategory').value;
    if (!category || !subcategory) {
        document.getElementById('issueError').textContent = 'Please select both category and subcategory.';
        isValid = false;
    }
    
    // Validate message
    const message = document.getElementById('message').value;
    if (!message) {
        document.getElementById('messageError').textContent = 'Message is required.';
        isValid = false;
    }
    
    return isValid;
}

// Reset form state
function resetForm() {
    uploadedFiles = [];
    selectedOrder = null;
    updateFilePreview();
    document.getElementById('issueSubcategory').innerHTML = '<option value="">Select Subcategory</option>';
    document.getElementById('orderSection').style.display = 'none';
    document.getElementById('orderList').innerHTML = '';
}

// Initialize form on page load
document.addEventListener('DOMContentLoaded', initForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geeta-ticket"] && !Shopify.designMode) return;
  try {
    
// Issue type mapping
const issueTypes = {
    "Order & Payment": [
        "Order Issues & Adjustments",
        "Payment Issues",
        "Tax Issues"
    ],
    "Track & Shipping": [
        "Shipping & Delivery",
        "Tracking Order",
        "Missing Package",
        "Damaged Package"
    ],
    "After Sale": [
        "Wig Usage & Installation",
        "Wig Maintenance & Care",
        "Return & Refund"
    ],
    "Product Information": [
        "Product Details",
        "Wig Features & Styles"
    ],
    "Rewards & Promotions": [
        "Sales Promotion",
        "Rewards Program"
    ],
    "VIP & Account": [
        "VIP Rewards",
        "Account Management"
    ]
};

// Order-related categories
const orderRelatedCategories = [
    "Order & Payment",
    "Track & Shipping",
    "After Sale"
];

// Get Worker URL from hidden field
const workerUrl = document.getElementById('workerUrlField').value;

// Add debugging info
console.log('Worker URL configured as:', workerUrl);

// Validate workerUrl immediately
if (!workerUrl || workerUrl === '' || workerUrl === '{{ section.settings.worker_url }}') {
    console.error('Error: Worker URL is not configured properly. Please set the Worker URL in the section settings.');
    alert('Error: Worker URL is not configured. Please contact support.');
}

// Global variables
let uploadedFiles = [];
let selectedOrder = null;

// Initialize form
function initForm() {
    const categorySelect = document.getElementById('issueCategory');
    const subcategorySelect = document.getElementById('issueSubcategory');
    const emailInput = document.getElementById('email');
    const fileUpload = document.getElementById('fileUpload');
    const fileInput = document.getElementById('fileInput');
    const form = document.getElementById('ticketForm');

    // Issue category change handler
    categorySelect.addEventListener('change', handleCategoryChange);
    
    // Email change handler for order lookup
    emailInput.addEventListener('change', handleEmailChange);
    
    // File upload handlers
    fileUpload.addEventListener('click', () => fileInput.click());
    fileInput.addEventListener('change', handleFileSelect);
    fileUpload.addEventListener('dragover', handleDragOver);
    fileUpload.addEventListener('drop', handleDrop);
    
    // Form submission handler
    form.addEventListener('submit', handleFormSubmit);
}

// Handle issue category change
function handleCategoryChange() {
    const categorySelect = document.getElementById('issueCategory');
    const subcategorySelect = document.getElementById('issueSubcategory');
    const selectedCategory = categorySelect.value;
    
    console.log('Category changed to:', selectedCategory);
    console.log('issueTypes object:', issueTypes);
    console.log('Issue types keys:', Object.keys(issueTypes));
    
    // Clear existing options
    subcategorySelect.innerHTML = '<option value="">Select Subcategory</option>';
    
    // Populate subcategories
    if (selectedCategory && issueTypes[selectedCategory]) {
        console.log('Found subcategories:', issueTypes[selectedCategory]);
        issueTypes[selectedCategory].forEach(subcategory => {
            const option = document.createElement('option');
            option.value = subcategory;
            option.textContent = subcategory;
            subcategorySelect.appendChild(option);
        });
    } else {
        console.error('No subcategories found for category:', selectedCategory);
    }
    
    // Show/hide order section based on category
    const orderSection = document.getElementById('orderSection');
    if (orderRelatedCategories.includes(selectedCategory)) {
        orderSection.style.display = 'block';
        // Trigger order lookup if email is provided
        const email = document.getElementById('email').value;
        if (email) {
            lookupOrders(email);
        }
    } else {
        orderSection.style.display = 'none';
        selectedOrder = null;
        document.getElementById('selectedOrder').value = '';
        document.getElementById('orderList').innerHTML = '';
    }
}

// Handle email change for order lookup
function handleEmailChange() {
    const email = this.value;
    const categorySelect = document.getElementById('issueCategory');
    const selectedCategory = categorySelect.value;
    
    console.log('Email changed to:', email);
    console.log('Current category:', selectedCategory);
    console.log('Order-related categories:', orderRelatedCategories);
    
    // Only lookup orders if category is order-related
    if (email && orderRelatedCategories.includes(selectedCategory)) {
        console.log('Initiating order lookup for email:', email);
        lookupOrders(email);
    }
}

// Lookup orders from Shopify via Worker
async function lookupOrders(email) {
    const orderList = document.getElementById('orderList');
    const orderLoading = document.getElementById('orderLoading');
    
    orderLoading.classList.remove('hidden');
    orderList.innerHTML = '';
    
    try {
        // Validate workerUrl
        if (!workerUrl || workerUrl === '') {
            orderList.innerHTML = '<div style="padding: 1rem; text-align: center; color: #e53e3e;">Error: Worker URL is not configured.</div>';
            return;
        }
        
        const ordersUrl = `${workerUrl}/orders?email=${encodeURIComponent(email)}`;
        console.log('Looking up orders at:', ordersUrl);
        
        const response = await fetch(ordersUrl);
        console.log('Orders response status:', response.status);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const orders = await response.json();
        
        if (orders.length > 0) {
            orders.forEach(order => {
                // Create expandable order container
                const orderContainer = document.createElement('div');
                orderContainer.className = 'order-item';
                
                // Order header with click handler
                const orderHeader = document.createElement('div');
                orderHeader.className = 'order-header';
                
                // Get first product for preview
                const firstProduct = order.line_items && order.line_items.length > 0 ? order.line_items[0] : null;
                const productCount = order.line_items && order.line_items.length || 0;
                
                // Generate product preview HTML
                let productPreviewHtml = '';
                if (firstProduct) {
                    const imageUrl = firstProduct.image_url || 'https://geetahair.com/cdn/shop/files/GeetaHair-Logo_200x.png?v=1710713035';
                    const truncatedTitle = firstProduct.name.length > 30 ? firstProduct.name.substring(0, 30) + '...' : firstProduct.name;
                    
                    productPreviewHtml = `
                        <div class="order-product-preview">
                            <img src="${imageUrl}" alt="${firstProduct.name}" class="order-product-image">
                            <div class="order-product-info">
                                <div class="order-product-title">${truncatedTitle}</div>
                                <div class="order-product-count" onclick="toggleProductList(event, this)">${productCount} Order Items</div>
                            </div>
                        </div>
                    `;
                }
                
                orderHeader.innerHTML = `
                    <div class="order-header-main">
                        <div class="order-header-info">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <strong>${order.name}</strong>
                                <span class="order-arrow">▼</span>
                            </div>
                            Status: ${order.status}<br>
                            Date: ${new Date(order.created_at).toLocaleDateString()}<br>
                            Total: ${order.total_price} ${order.currency}
                        </div>
                        ${productPreviewHtml}
                    </div>
                `;
                
                // Products list container (initially hidden)
                const productsContainer = document.createElement('div');
                productsContainer.className = 'order-products';
                productsContainer.style.display = 'none';
                productsContainer.style.marginTop = '1rem';
                productsContainer.style.paddingTop = '1rem';
                productsContainer.style.borderTop = '1px solid #eee';
                
                // Add products to the container
                if (order.line_items && order.line_items.length > 0) {
                    productsContainer.innerHTML = '<h4 style="margin: 0 0 0.5rem 0; font-size: 0.9rem;">Products:</h4>';
                    
                    const productsList = document.createElement('div');
                    productsList.className = 'products-list';
                    
                    order.line_items.forEach((product, index) => {
                        // Product item container
                        const productItem = document.createElement('div');
                        productItem.className = 'product-item';
                        
                        // Product checkbox
                        const checkbox = document.createElement('input');
                        checkbox.type = 'checkbox';
                        checkbox.id = `product-${order.id}-${index}`;
                        checkbox.name = `product-${order.id}-${index}`;
                        checkbox.value = JSON.stringify(product);
                        checkbox.className = 'product-checkbox';
                        
                        // Add change event listener to update selected products when checkbox changes
                        checkbox.addEventListener('change', () => {
                            selectOrder(orderItem, order);
                        });
                        
                        // Product image container
                        const imageContainer = document.createElement('div');
                        imageContainer.className = 'product-image-container';
                        
                        // Product image - use image from API if available
                        const productImage = document.createElement('img');
                        productImage.className = 'product-image';
                        productImage.alt = product.name;
                        
                        // Use the image_url from the API response, fallback to brand logo if not available
                        const imageUrl = product.image_url || 'https://geetahair.com/cdn/shop/files/GeetaHair-Logo_200x.png?v=1710713035';
                        productImage.src = imageUrl;
                        
                        // Add image to container
                        imageContainer.appendChild(productImage);
                        
                        // Product content container
                        const productContent = document.createElement('div');
                        productContent.className = 'product-content';
                        
                        // Product info container
                        const productInfo = document.createElement('div');
                        productInfo.className = 'product-info';
                        
                        // Product name with variant info
                        const productName = document.createElement('strong');
                        productName.textContent = product.name;
                        
                        // Variant title information
                        const variantInfo = document.createElement('span');
                        const variantText = product.variant_title && product.variant_title !== 'N/A' ? product.variant_title : `SKU: ${product.sku || 'N/A'}`;
                        variantInfo.textContent = `${variantText} | ${product.quantity} x ${product.price} ${order.currency}`;
                        
                        // Add name and variant info to product info
                        productInfo.appendChild(productName);
                        productInfo.appendChild(variantInfo);
                        
                        // Add image and info to product content
                        productContent.appendChild(imageContainer);
                        productContent.appendChild(productInfo);
                        
                        // Assemble product item
                        productItem.appendChild(productContent);
                        productItem.appendChild(checkbox);
                        productsList.appendChild(productItem);
                    });
                    
                    productsContainer.appendChild(productsList);
                } else {
                    productsContainer.innerHTML = '<p style="font-size: 0.85rem; color: #666;">No products found in this order.</p>';
                }
                
                // Toggle product list visibility when order header is clicked
                orderHeader.addEventListener('click', () => {
                    if (productsContainer.style.display === 'none') {
                        productsContainer.style.display = 'block';
                        orderHeader.querySelector('.order-arrow').textContent = '▲';
                    } else {
                        productsContainer.style.display = 'none';
                        orderHeader.querySelector('.order-arrow').textContent = '▼';
                    }
                });
                
                // Select order handler for the whole container
                orderContainer.addEventListener('click', (e) => {
                    // Only select order if not clicking on checkbox or label
                    if (!e.target.closest('.product-checkbox') && !e.target.closest('label')) {
                        selectOrder(orderContainer, order);
                    }
                });
                
                // Add header and products to order container
                orderContainer.appendChild(orderHeader);
                orderContainer.appendChild(productsContainer);
                orderContainer.dataset.order = JSON.stringify(order);
                
                orderList.appendChild(orderContainer);
            });
        } else {
            orderList.innerHTML = '<div style="padding: 1rem; text-align: center; color: #666;">No orders found for this email.</div>';
        }
    } catch (error) {
        console.error('Error looking up orders:', error);
        orderList.innerHTML = `<div style="padding: 1rem; text-align: center; color: #e53e3e;">Failed to load orders: ${error.message}</div>`;
    } finally {
        orderLoading.classList.add('hidden');
    }
}

// Select an order and track selected products
function selectOrder(orderItem, orderData) {
    // Remove selected class from all items
    document.querySelectorAll('.order-item').forEach(item => {
        item.classList.remove('selected');
    });
    
    // Add selected class to clicked item
    orderItem.classList.add('selected');
    
    // Get all checked products for this order
    const checkedProducts = [];
    const checkboxes = orderItem.querySelectorAll('.product-checkbox:checked');
    
    checkboxes.forEach(checkbox => {
        checkedProducts.push(JSON.parse(checkbox.value));
    });
    
    // Store selected order with checked products
    selectedOrder = {
        ...JSON.parse(orderItem.dataset.order),
        selected_products: checkedProducts
    };
    
    console.log('Selected order with products:', selectedOrder);
    
    // Store in hidden field
    document.getElementById('selectedOrder').value = JSON.stringify(selectedOrder);
}

// Handle file selection
function handleFileSelect(event) {
    const files = Array.from(event.target.files);
    processFiles(files);
    event.target.value = ''; // Reset input
}

// Handle drag over
function handleDragOver(event) {
    event.preventDefault();
    event.currentTarget.style.borderColor = '#0070f3';
}

// Handle drop
function handleDrop(event) {
    event.preventDefault();
    event.currentTarget.style.borderColor = '#ddd';
    const files = Array.from(event.dataTransfer.files);
    processFiles(files);
}

// Process files for upload
async function processFiles(files) {
    const fileUpload = document.getElementById('fileUpload');
    
    // Add loading state to file upload container
    fileUpload.classList.add('loading');
    
    try {
        for (const file of files) {
            // Validate file size
            if (!validateFileSize(file)) {
                alert(`${file.name} exceeds the file size limit.`);
                continue;
            }
            
            let processedFile = file;
            
            // Compress images
            if (file.type.startsWith('image/')) {
                processedFile = await compressImage(file);
            }
            
            // Upload file to R2
            const uploadUrl = await uploadFile(processedFile);
            if (uploadUrl) {
                uploadedFiles.push({
                    name: file.name,
                    url: uploadUrl,
                    type: file.type
                });
                updateFilePreview();
            }
        }
    } finally {
        // Remove loading state after all files are processed
        fileUpload.classList.remove('loading');
    }
}

// Validate file size
function validateFileSize(file) {
    if (file.type.startsWith('image/')) {
        return file.size <= 10 * 1024 * 1024; // 10MB for images
    } else if (file.type.startsWith('video/')) {
        return file.size <= 50 * 1024 * 1024; // 50MB for videos
    }
    return false;
}

// Compress image
async function compressImage(file) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                
                // Resize image to max 1920px width/height
                let width = img.width;
                let height = img.height;
                const maxSize = 1920;
                
                if (width > height && width > maxSize) {
                    height = Math.round((height * maxSize) / width);
                    width = maxSize;
                } else if (height > maxSize) {
                    width = Math.round((width * maxSize) / height);
                    height = maxSize;
                }
                
                canvas.width = width;
                canvas.height = height;
                
                // Draw image
                ctx.drawImage(img, 0, 0, width, height);
                
                // Convert to blob
                canvas.toBlob(
                    (blob) => {
                        resolve(new File([blob], file.name, { type: file.type }));
                    },
                    file.type,
                    0.8 // Compression quality
                );
            };
        };
    });
}

// Upload file to R2 via Worker
async function uploadFile(file) {
    try {
        // Validate workerUrl
        if (!workerUrl || workerUrl === '') {
            alert('Error: Worker URL is not configured. Please contact support.');
            return null;
        }
        
        const uploadUrl = `${workerUrl}/upload`;
        console.log('Uploading file to:', uploadUrl);
        
        const formData = new FormData();
        formData.append('file', file);
        
        const response = await fetch(uploadUrl, {
            method: 'POST',
            body: formData
        });
        
        console.log('Upload response status:', response.status);
        
        if (response.ok) {
            const data = await response.json();
            return data.url;
        } else {
            const errorText = await response.text();
            console.error('File upload error:', errorText);
            alert(`File upload failed: ${response.status} ${response.statusText}`);
            return null;
        }
    } catch (error) {
        console.error('Error uploading file:', error);
        alert(`File upload error: ${error.message}`);
        return null;
    }
}

// Update file preview
function updateFilePreview() {
    const previewContainer = document.getElementById('filePreview');
    previewContainer.innerHTML = '';
    
    uploadedFiles.forEach((file, index) => {
        const previewItem = document.createElement('div');
        previewItem.className = 'file-preview-item';
        
        // Create remove button with proper event handling
        const removeBtn = document.createElement('button');
        removeBtn.className = 'remove-btn';
        removeBtn.innerHTML = '×';
        removeBtn.onclick = (event) => removeFile(event, index);
        
        if (file.type.startsWith('image/')) {
            const img = document.createElement('img');
            img.src = file.url;
            img.alt = file.name;
            previewItem.appendChild(img);
        } else if (file.type.startsWith('video/')) {
            const video = document.createElement('video');
            video.controls = true;
            const source = document.createElement('source');
            source.src = file.url;
            source.type = file.type;
            video.appendChild(source);
            previewItem.appendChild(video);
        }
        
        // Append remove button
        previewItem.appendChild(removeBtn);
        
        // Add click handler to preview item to prevent event propagation
        previewItem.addEventListener('click', (event) => {
            event.stopPropagation();
        });
        
        previewContainer.appendChild(previewItem);
    });
    
    // Update hidden input
    document.getElementById('uploadedFiles').value = JSON.stringify(uploadedFiles);
}

// Remove file from upload list
function removeFile(event, index) {
    // Stop event propagation to prevent triggering file upload click
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
    uploadedFiles.splice(index, 1);
    updateFilePreview();
}

// Handle form submission
async function handleFormSubmit(event) {
    event.preventDefault();
    
    // Validate workerUrl with template syntax check
    if (!workerUrl || workerUrl === '' || workerUrl.includes('{{') || workerUrl.includes('}}')) {
        const errorMsg = 'Error: Worker URL is not configured properly. Please follow these steps:\n1. Go to Shopify Admin > Online Store > Themes > Customize\n2. Find "Shopify Ticket Form" section\n3. Enter your Cloudflare Worker URL in the "Worker URL" field\n4. Save the changes\n\nIf you need help, please contact support.';
        console.error(errorMsg);
        console.log('Current Worker URL:', workerUrl);
        alert(errorMsg);
        return;
    }
    
    const form = event.target;
    const submitBtn = document.getElementById('submitBtn');
    
    // Validate form
    if (!validateForm()) {
        return;
    }
    
    // Show loading state with user-provided SVG
    submitBtn.disabled = true;
    submitBtn.innerHTML = `<span class="loading"><svg t="1767593342787" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2868" width="18" height="18"><path d="M144.205 202.496a136.678 136.678 0 1 0 273.357 0 136.678 136.678 0 1 0-273.357 0zM41.728 492.902a119.578 119.578 0 1 0 239.155 0 119.578 119.578 0 1 0-239.155 0zM144.23 749.158a102.502 102.502 0 1 0 205.005 0 102.502 102.502 0 1 0-205.005 0zM435.2 861.926a89.6 89.6 0 1 0 179.2 0 89.6 89.6 0 1 0-179.2 0z m289.843-95.666a85.427 85.427 0 1 0 170.855 0 85.427 85.427 0 1 0-170.855 0z m136.704-290.433a68.326 68.326 0 1 0 136.653 0 68.326 68.326 0 1 0-136.653 0zM759.22 219.571a51.251 51.251 0 1 0 102.502 0 51.251 51.251 0 1 0-102.503 0zM512 85.376a34.176 34.176 0 1 0 68.352 0 34.176 34.176 0 1 0-68.352 0z" p-id="2869" fill="#ffffff"></path></svg></span> Submitting...`;
    
    try {
        // Create JSON payload instead of FormData
        const payload = {
            email: document.getElementById('email').value,
            phone: document.getElementById('phone').value,
            issueCategory: document.getElementById('issueCategory').value,
            issueSubcategory: document.getElementById('issueSubcategory').value,
            message: document.getElementById('message').value,
            selectedOrder: selectedOrder,
            uploadedFiles: uploadedFiles
        };
        
        // Print API URL for debugging
        const apiUrl = `${workerUrl}/ticket`;
        console.log('Submitting ticket to:', apiUrl);
        console.log('Submission payload:', payload);
        
        // Submit form with JSON
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        
        // Print response status
        console.log('Response status:', response.status);
        
        const responseData = await response.json();
        console.log('Response data:', responseData);
        
        if (response.ok) {
            console.log('Ticket submission result:', responseData);
            alert('Ticket submitted successfully!');
            form.reset();
            resetForm();
        } else {
            console.error('Error response:', responseData);
            alert(`Failed to submit ticket: ${response.status} ${responseData.error || response.statusText}`);
        }
    } catch (error) {
        console.error('Error submitting ticket:', error);
        alert(`Failed to submit ticket: ${error.message}`);
    } finally {
        // Reset button state
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'Submit Ticket';
    }
}

// Validate form
function validateForm() {
    let isValid = true;
    
    // Reset errors
    document.querySelectorAll('.error-message').forEach(el => el.textContent = '');
    
    // Validate email
    const email = document.getElementById('email').value;
    if (!email) {
        document.getElementById('emailError').textContent = 'Email is required.';
        isValid = false;
    }
    
    // Validate issue type
    const category = document.getElementById('issueCategory').value;
    const subcategory = document.getElementById('issueSubcategory').value;
    if (!category || !subcategory) {
        document.getElementById('issueError').textContent = 'Please select both category and subcategory.';
        isValid = false;
    }
    
    // Validate message
    const message = document.getElementById('message').value;
    if (!message) {
        document.getElementById('messageError').textContent = 'Message is required.';
        isValid = false;
    }
    
    return isValid;
}

// Reset form state
function resetForm() {
    uploadedFiles = [];
    selectedOrder = null;
    updateFilePreview();
    document.getElementById('issueSubcategory').innerHTML = '<option value="">Select Subcategory</option>';
    document.getElementById('orderSection').style.display = 'none';
    document.getElementById('orderList').innerHTML = '';
}

// Toggle product list visibility when clicking on product count
function toggleProductList(event, element) {
    event.stopPropagation(); // Prevent triggering the order header click
    
    // Find the parent order item
    const orderItem = element.closest('.order-item');
    if (!orderItem) return;
    
    // Find the products container
    const productsContainer = orderItem.querySelector('.order-products');
    const orderArrow = orderItem.querySelector('.order-arrow');
    
    if (productsContainer && orderArrow) {
        if (productsContainer.style.display === 'none') {
            productsContainer.style.display = 'block';
            orderArrow.textContent = '▲';
        } else {
            productsContainer.style.display = 'none';
            orderArrow.textContent = '▼';
        }
    }
}

// Auto-select issue type based on URL parameters
function autoSelectIssueType() {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    
    // New format: categories parameter with single category value
    const categoriesParam = urlParams.get('categories');
    
    if (categoriesParam) {
        // Convert categories parameter to proper category name
        const categoryMap = {
            'order-payment': 'Order & Payment',
            'track-shipping': 'Track & Shipping',
            'after-sale': 'After Sale',
            'product-information': 'Product Information',
            'rewards-promotions': 'Rewards & Promotions',
            'vip-account': 'VIP & Account'
        };
        
        // Get the proper category name from the mapping
        const category = categoryMap[categoriesParam.toLowerCase()] || '';
        
        // Set category if found in mapping
        if (category) {
            const categorySelect = document.getElementById('issueCategory');
            categorySelect.value = category;
            
            // Trigger change event to populate subcategories
            const changeEvent = new Event('change');
            categorySelect.dispatchEvent(changeEvent);
        }
    }
}

// Initialize form on page load
document.addEventListener('DOMContentLoaded', () => {
    initForm();
    // Auto-select issue type after form initialization
    autoSelectIssueType();
});

/*
URL参数格式说明：

1. 标准格式：
   - 类别参数：?categories=category-value
   - 示例：https://example.com/faq?categories=order-payment
   
2. 类别参数值映射：
   | URL参数值 | 对应分类名称 |
   |----------|-------------|
   | order-payment | Order & Payment |
   | track-shipping | Track & Shipping |
   | after-sale | After Sale |
   | product-information | Product Information |
   | rewards-promotions | Rewards & Promotions |
   | vip-account | VIP & Account |
*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-page-countdown"] && !Shopify.designMode) return;
  try {
    
// 确保脚本在正确的位置初始化
// 这里的代码会被自动插入到页面底部

  } catch(e) { console.error(e); }
})();
})();
